import Vue from 'vue'
// 流媒体数据字段
export function dataMedia() {
  return {
    type: "14",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "流媒体",
    field_i18n: "PE.StreamMedia",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    pictureW: 200,
    pictureH: 150,
    field_item_id: "0",
    field_item_val: "", // 存储标题文本
    ext_val_url: "", // 视频或者图片url
    ext_val_pimg: "", // 视频首帧图
    ext_val_scaleType: false, // 约束比例
    ext_val_name: "",
    ext_val_size: 0,
    ext_val_wh: "", // 文件宽高尺寸
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    ext_val_volume: 50,
    ext_val_rotation: 0,
    ext_val_isVolumeGradual: false,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}

// Rss数据字段
export function dataRss() {
  return {
    type: "17",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "RSS",
    field_i18n: "PE.RSS",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    pictureW: 200,
    pictureH: 150,
    field_item_id: "0",
    field_item_val: "", // 存储标题文本
    ext_val_url: "", // url
    ext_val_refreshInterval: 0,
    ext_val_isTitleShow: false,
    ext_val_titleColor: "rgba(255,255,255,1)",
    ext_val_titleTextStyle: "SimSun",
    ext_val_titleTextSize: 16,
    ext_val_isTitleBold: false,
    ext_val_isTitleItalic: false,
    ext_val_isTitleUnderLine: false,
    ext_val_isContentShow: false,
    ext_val_contentColor: "rgba(255,255,255,1)",
    ext_val_contentTextStyle: "SimSun",
    ext_val_contentTextSize: 16,
    ext_val_isContentBold: false,
    ext_val_isContentItalic: false,
    ext_val_isContentUnderLine: false,
    ext_val_isDateShow: false,
    ext_val_dateColor: "rgba(255,255,255,1)",
    ext_val_dateTextStyle: "SimSun",
    ext_val_dateTextSize: 16,
    ext_val_isDateBold: false,
    ext_val_isDateItalic: false,
    ext_val_isDateUnderLine: false,
    ext_val_scrollDirection: 0,
    ext_val_scrollSpeed: 0,
    ext_val_turnPageTime: 0,
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 网页数据字段
export function dataWebpage() {
  return {
    type: "18",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "网页",
    field_i18n: "PE.Webpage",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    pictureW: 200,
    pictureH: 150,
    field_item_id: "0",
    field_item_val: "", // 存储标题文本
    ext_val_url: "", // 视频或者图片url
    ext_val_pimg: "", // 视频首帧图
    ext_val_scaleType: false, // 约束比例
    ext_val_name: "",
    ext_val_size: 0,
    ext_val_wh: "", // 文件宽高尺寸
    ext_val_duration: 10,
    ext_val_volume: 50,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    ext_val_rotation: 0,
    ext_val_isVolumeGradual: false,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 正计时数据字段
export function dataTimewait() {
  return {
    // 正计时
    type: "13",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "正计时",
    field_i18n: "PE.Timing",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    field_item_id: "0",
    field_item_val: "", // 存储标题文本
    ext_val_pimg: "",
    ext_val_text: "正计时",
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    ext_val_style: 1, // 展示风格
    ext_val_isRelativeTime: true, // 计时方式 true 相对 false 绝对
    ext_val_absoluteTime: new Date(), // 绝对时间
    ext_val_relativeTime: 60, // 相对时间秒（1 min）
    ext_val_showDay: true,
    ext_val_showHour: true,
    ext_val_showMinute: true,
    ext_val_showSecond: true,
    ext_val_singleLine: true, // 单行  true  多行  false
    ext_val_family: "SimSun",
    ext_val_textSize: 16,
    ext_val_textColor: "rgba(255,255,255,1)",
    ext_val_backgroundColor: "rgba(255,255,255,0)",
    ext_val_size: 0,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 倒计时数据字段
export function dataCountdown() {
  return {
    // 倒计时
    type: "12",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "倒计时",
    field_i18n: "PE.Countdown",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    field_item_id: "0",
    field_item_val: "", // 存储标题文本
    ext_val_pimg: "",
    ext_val_text: "倒计时",
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    ext_val_style: 1, // 展示风格
    ext_val_isRelativeTime: true, // 计时方式 true 相对 false 绝对
    ext_val_absoluteTime: new Date(), // 绝对时间
    ext_val_relativeTime: 60, // 相对时间秒（1 min）
    ext_val_showDay: true,
    ext_val_showHour: true,
    ext_val_showMinute: true,
    ext_val_showSecond: true,
    ext_val_singleLine: true, // 单行  true  多行  false
    ext_val_family: "SimSun",
    ext_val_textSize: 16,
    ext_val_textColor: "rgba(255,255,255,1)",
    ext_val_backgroundColor: "rgba(255,255,255,0)",
    ext_val_size: 0,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 文本数据字段
export function dataText() {
  return {
    type: "4",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "文本",
    field_i18n: "PE.Text",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    field_item_id: "0",
    field_item_val: "",
    ext_val_pimg: "",
    // ext_val_mode: "0", // 1 滚动 5 翻页 0 静止
    ext_val_scrollDirection: 0,
    ext_val_scrollSpeed: 1,
    ext_val_singleLine: true,
    ext_val_isLoop: true,
    ext_val_isBold: false,
    ext_val_isItalic: false,
    ext_val_underLine: false,
    ext_val_halign: 1,
    ext_val_valign: 32,
    ext_val_textStyle: 0,
    ext_val_family: "SimSun",
    ext_val_textSize: 16,
    ext_val_textColor: "rgba(255,255,255,1)",
    ext_val_backgroundColor: "rgba(255,255,255,0)",
    ext_val_size: 0, // 模块默认属性，用于文件大小，没有为0
    ext_val_content: "",
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 文件数据字段 type:图片2/视频1
export function dataImage() {
  return {
    type: "2",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "图片",
    field_i18n: "PE.Picture",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    pictureW: 200,
    pictureH: 150,
    field_item_id: "0", // 视频id
    field_item_val: "", // 视频地址
    ext_val_pimg: "", // 视频首帧图
    ext_val_scaleType: false, // 约束比例
    ext_val_name: "",
    ext_val_size: 0,
    ext_val_duration: 10,
    ext_val_enterTime: 2,
    ext_val_anim: "RANDOM",
    ext_val_resolution: "",
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 文件数据字段 type:图片2/视频1
export function dataVideo() {
  return {
    type: "1",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "视频",
    field_i18n: "PE.Video",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    pictureW: 200,
    pictureH: 150,
    field_item_id: "0", // 视频id
    field_item_val: "", // 视频地址
    ext_val_pimg: "", // 视频首帧图
    ext_val_scaleType: false, // 约束比例
    ext_val_volume: 50,
    ext_val_name: "",
    ext_val_size: 0,
    ext_val_playTime: 0,
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    ext_val_resolution: "",
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 数字时钟数据字段
export function dataNClock() {
  return {
    type: "6",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "数字时钟",
    field_i18n: "PE.Digital",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    field_item_id: "0",
    field_item_val: "",
    ext_val_pimg: "",
    ext_val_showDate: true, // 日期
    ext_val_showWeek: true, // 星期
    ext_val_showTime: true, // 时间
    ext_val_showLunar: true, // 农历
    ext_val_dateStyle: "yyyy/MM/dd", // 日期格式
    ext_val_style: "yyyy/MM/dd", // 日期格式
    ext_val_singleLine: false, // 单行  true  多行  false
    ext_val_tzId: "Asia/Shanghai",
    ext_val_tzCount: 8, // 时区数值，用于计算不同时区时间
    ext_val_tzLabel: "(UTC+08:00)北京/Beijing",
    ext_val_family: "SimSun",
    ext_val_textSize: 16,
    ext_val_textColor: "rgba(255,255,255,1)",
    ext_val_backgroundColor: "rgba(255,255,255,0)",
    ext_val_size: 0,
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 模拟时钟数据字段
export function dataIClock() {
  return {
    type: "7",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "模拟时钟",
    field_i18n: "PE.Analog",
    field_item_id: "0",
    field_item_val: "",
    ext_val_pimg: "",
    ext_val_backgroundColor: "rgba(0, 0, 0, 0)", // 背景
    ext_val_hourCircleColor: "rgba(255, 0, 0, 1)", // 时标
    ext_val_minCircleColor: "rgba(0, 255, 0, 1)", // 分标
    ext_val_hourHandColor: "rgba(255, 0, 0, 1)", // 时钟
    ext_val_minHandColor: "rgba(0, 255, 0, 1)", // 分钟
    ext_val_secHandColor: "rgba(0, 0, 255, 1)",// 秒钟
    ext_val_showText: true,
    // ext_val_textColor: "rgba(255,255,255,0)",
    ext_val_textColor: "rgba(255,255,255,1)",
    ext_val_textSize: 16,
    ext_val_tzId: "Asia/Shanghai",
    ext_val_tzCount: 8, // 时区数值，用于计算不同时区时间
    ext_val_tzLabel: "(UTC+08:00)北京/Beijing",
    ext_val_size: 0,
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    x: 0,
    y: 0,
    w: 200,
    h: 200,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 天气数据字段
export function dataWeather() {
  return {
    type: "5",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "天气",
    field_i18n: "PE.Weather",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    field_item_id: "0",
    field_item_val: "",
    ext_val_pimg: "",
    ext_val_provinceCode: "101010", // 省份代码 默认北京
    ext_val_cityCode: "101010100", // 城市代码 默认北京
    ext_val_city: "北京", // 城市名
    ext_val_bPlaceShow: true, // 是否展示城市
    ext_val_wenduShow: true, // 是否展示温度
    ext_val_bTempShow: true, // 是否展示天气
    ext_val_bWindShow: true, // 是否展示风力
    ext_val_bHumidityShow: true, // 是否展示湿度
    ext_val_bWearShow: false, // 穿衣指数
    ext_val_isSingleLine: false, // 单行  true  多行  false
    ext_val_family: "SimSun",
    ext_val_textSize: 16,
    ext_val_textColor: "rgba(255,255,255,1)",
    ext_val_backgroundColor: "rgba(255,255,255,0)",
    ext_val_size: 0,
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}
// 日历数据字段
export function dataCalendar() {
  return {
    type: "",
    field: Vue.prototype.$uuid.v4(),
    field_cn: "日历",
    field_i18n: "PE.Calendar",
    x: 0,
    y: 0,
    w: 200,
    h: 150,
    field_item_id: "0",
    field_item_val: "",
    ext_val_pimg: "",
    ext_val_lunar: "1", // 1 显示 2 隐藏
    ext_val_size: 0,
    ext_val_duration: 10,
    ext_val_anim: "RANDOM",
    ext_val_enterTime: 2,
    style: {
      fs: "0", // 1 全屏铺满 2 水平铺满 3 垂直铺满
      ha: "0", // 1 水平居左 2 水平居中 3 水平居右
      va: "0" // 1 垂直靠底 2 垂直居中 3 垂直靠顶
    },
    wicket: []
  };
}

// export const dataField = {
//   dataMedia,
//   dataRss,
//   dataTimewait,
//   dataCountdown,
//   dataText,
//   dataFile,
//   dataNClock,
//   dataIClock,
//   dataWeather,
//   dataCalendar
// }

// 数据折叠
export function dataFold(data) {
  let dataF = {
    field_item: {
      ext_val: {}
    }
  };
  for (let value in data) {
    if (value.indexOf("field_item") !== -1) {
      dataF.field_item[value.split('_')[2]] = data[value];
    } else if (value.indexOf("ext_val") !== -1) {
      let key = value.split('_')[2];
      dataF.field_item.ext_val[key] = data[value];
    } else {
      dataF[value] = data[value];
    }
  }
  return dataF;
}

// 数据扁平化
export function dataFlattening(data) {
  let dataF = {};
  for (let value in data) {
    if (value.indexOf("field_item") !== -1) {
      for (let field in data[value]) {
        if (field.indexOf("ext_val") !== -1) {
          for (let ext in data[value][field]) {
            dataF[`ext_val_${ext}`] = data[value][field][ext];
          }
        } else {
          dataF[`field_item_${field}`] = data[value][field];
        }
      }
    } else {
      dataF[value] = data[value];
    }
  }
  return dataF;
}

// 颜色数据转化
export function colorSwitch(rgba) {
  rgba = rgba.replace(/\s*/g, "");
  let cList = rgba.match(/(?<=\()(\d+),(\d+),(\d+),((?:0?\.\d+)|1)(?=\))/);
  let color = `${parseInt(cList[1]).toString(16)}${parseInt(cList[2]).toString(16)}${parseInt(cList[3]).toString(16)}`;
  let alpha = Math.round(Number(cList[4]) * 255).toString(16);
  return alpha + color;
}

//十六进制转十进制
export function hexToD(hex) {
  hex = hex.replace(/#/, "").toLocaleUpperCase();
  return hex;
}

//十进制转十六进制
export function dToHex(d) {
  return d;
}